import Typography from "typography"
import lincolnTheme from "typography-theme-lincoln"

const typography = new Typography(lincolnTheme)

export default typography
export const rhythm = typography.rhythm